const BASE = '/v1/Defect';

export default (instance) => ({
  getDefects: (params = {}) => instance.get(BASE, { params })
});
